import { NavLink } from "react-router-dom";
import styled from "styled-components";

export const NFTDetailContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    padding: 2rem;
    margin-top: 2rem;
    ${({ theme }) => theme.mediaWidth.upToLarge`
        flex-direction: column;
        width: 98%;
    `}
`

export const DetailImage = styled.div`
    width: 40%;
    max-height: 600px;
    display: flex;
    align-items: center;
    justify-content: center;
    //background: ${({ theme }) => theme.newBg3};
    margin: 0 1rem;
    overflow: hidden;
    img {
        max-width: 100%;
        max-height: 100%;
        box-shadow: ${({ theme }) => theme.boxShadow};
        border-radius: 2rem;
        border: 2px solid ${({ theme }) => theme.yetiBlue};
    }
    ${({ theme }) => theme.mediaWidth.upToLarge`
        width: 100%;
    `}

    .crypto-seal-bg {
    }
  
    .crypto-seal-character {
      position: absolute;
      width: 20%;
    }
  
    .crypto-dappers-image {
      width: 250px;
      image-rendering: -webkit-crisp-edges;
      image-rendering: pixelated;
      image-rendering: crisp-edges;
    }
  
    .pixelated-image {
      width: 250px;
      image-rendering: -webkit-crisp-edges;
      image-rendering: pixelated;
      image-rendering: crisp-edges;
    }
  
    .crypto-companions-image {
      width: 250px;
      image-rendering: -webkit-crisp-edges;
      image-rendering: pixelated;
      image-rendering: crisp-edges;
    }
  
`

export const DetailInfo = styled.div`
    width: 25%;
    display: flex;
    flex-direction: column;
    margin-left: 2rem;
    ${({ theme }) => theme.mediaWidth.upToLarge`
        width: 100%;
        margin-top: 2rem;
        margin-left: 1rem;
    `}
`

export const DetailInfoTitle = styled.span`
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 1.5rem;
    font-weight: bold;
    margin-bottom: 10px;
    user-select: none;
`

export const DetailCollection = styled(NavLink)`
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 1rem;
    font-style: italic;
    margin-bottom: 10px;
    text-decoration: none;
    color: ${({ theme }) => theme.text2};
    font-size: 1rem;
    width: fit-content;
    font-weight: 500;
    svg {
        margin-right: 0.3rem;
        fill: rgb(32, 129, 226);
    }
`

export const DetailSellerCreator = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    margin-bottom: 10px;

    > div {
        background: ${({ theme }) => theme.newBg2};
        padding: 1rem;
        border-radius: 0.5rem;
        margin: 0.5rem;
        width: 200px;
    }
`

export const NFTCategory = styled.div`
    padding: 0.5rem 1rem;
    background: ${({ theme }) => theme.primary1};
    border-radius: 0.2rem;
    margin: 0.5rem;
    width: fit-content;
    font-weight: 400;
    font-size: 0.8rem;
    font-style: italic;
`

export const NFTPriceWrapper = styled.div`
    background: ${({ theme }) => theme.newBg2};
    padding: 1rem;
    border-radius: 0.5rem;
    margin: 0.5rem;
    width: calc(100% - 1rem);
    display: flex;
    flex-direction: column;
    //align-items: center;
    justify-content: space-between;
    > * {
        margin-bottom: 0.5rem;
        &:only-child {
            margin-bottom: 0;
        }
    }
`

export const NFTPrice = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    span {
        font-size: 1rem;
        font-style: italic;
        margin-right: 0.5rem;
    }
    > div {
        display:flex;
        flex-direction: row;
        align-items: center;
        font-size: 1.2rem;
        font-weight: 500;
    }
`

export const NFTButtonsWrapper = styled.div`
    width: fit-content;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin: 2rem 0;
    width: 100%;
    > div {
        width: 50%;
        flex: unset;
        height: 4rem;
    }
`

export const NFTRoyalties = styled.div`
    width: fit-content;
    display: flex;
    flex-direction: row;
    align-items: center;
    background: ${({ theme }) => theme.newBg2};
    border-radius: 0.5rem;

    > span {
        font-size: 1rem;
        margin-right: 0.5rem;
    }

    > div {
        font-size: 1.1rem;
        font-weight: 500;
        font-style: italic;
    }
`

export const NFTDescription = styled.div`
    padding: 1rem;
    margin: 1rem 0;
`

export const NFTProperties = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
`

export const NFTPropertyItem = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 150px;
    padding: 0.5rem 1rem;
    border: 1px solid ${({ theme }) => theme.newBg1};
    border-radius: 1rem;
    //min-width: 100px;
    margin: 0.5rem;

    &.removable {
        position: relative;
        .remove-icon {
            display: none;
            width: 100%;
            height: 100%;
            opacity: 0.7;
            position: absolute;
            z-index: 1;
            background: ${({ theme }) => theme.yetiBlue};
            align-items: center;
            justify-content: center;
            border-radius: 1rem;
        }
        &:hover {
            cursor: pointer;
            .remove-icon {
                display: flex;
            }
        }
    }

    &.hasURL {
        > div {
            cursor: pointer;
            text-decoration: underline;
        }
    }

    > span {
        font-size: 0.8rem;
        font-weight: 500;
        margin-bottom: 0.5rem;
        color: ${({ theme }) => theme.yetiBlue};
    }

    > div {
        font-size: 0.9rem;
        font-weight: bold;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 120px;
    }

   
`

export const NFTSaleHistoryItem = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 90%;
    padding: 0.5rem 1rem;
    border: 1px solid ${({ theme }) => theme.newBg1};
    border-radius: 1rem;
    //min-width: 100px;
    margin: 1rem;

    > span {
        font-size: 0.8rem;
        font-weight: 500;
        margin-bottom: 0.5rem;
        color: ${({ theme }) => theme.yetiBlue};
    }

    > div {
        font-size: 0.9rem;
        font-weight: bold;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: calc(100% - 1rem);
        display: flex;
        align-items: center;
    }
`

export const NFTLikeCount = styled.div`
    height: 32px;
    min-width: 64px;
    max-width: 100px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    font-size: 0.8rem;
    font-weight: bold;
    z-index: 1;
    background: ${({ theme }) => theme.newBg2};
    border-radius: 0.5rem;
    margin: 0.5rem;

    > svg {
        margin-right: 5px;
        &:only-child {
            margin-right: 0;
        }
    }

    &.liked,
    &:hover {
        cursor: pointer;
        > svg {
            color: ${({ theme }) => theme.red2};
            font-size: 0.9rem;
        }
    }
`;